import React from 'react';
import { ReactComponent as BreadCrumbCaret } from 'img/arrows/breadcrumb-caret.svg'
import { BreadcrumbData } from 'types/breadcrumb-data';
import { Link } from 'gatsby';

interface BreadcrumbsProps extends React.PropsWithChildren {
    data?: BreadcrumbData[];
}

const getBreadcrumbListItem = (breadcrumb: BreadcrumbData, position: number) => {
    if (breadcrumb.linkBreadcrumb && breadcrumb.path) {
        return (
            <span property="itemListElement" typeof="ListItem">
                <Link property="item" typeof="WebPage" title={breadcrumb.longTitle} to={breadcrumb.path}>
                    <span property="name">{breadcrumb.shortTitle}</span>
                </Link>
                <meta property="position" content={`${position}`} />
            </span>
        );
    }

    return (
        <span property="itemListElement" typeof="ListItem">
            <span property="name">{breadcrumb.shortTitle}</span>
            {breadcrumb.path &&
                <meta property="url" content={breadcrumb.path} />
            }
            <meta property="position" content={`${position}`} />
        </span>
    );
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({data}) => {
    if (data === undefined) {
        return;
    }

    return (
        <nav className="breadcrumbs" aria-label="Site Breadcrumbs">
            <div className="container">
                {data.map((breadcrumb, index) => {
                    const position = index + 1;
                    return (
                        <React.Fragment key={index}>
                            {getBreadcrumbListItem(breadcrumb, position)}
                            {position < data.length &&
                                <span>
                                    <BreadCrumbCaret />
                                </span>
                            }
                        </React.Fragment>
                    );
                })}
            </div>
        </nav>
    );
};

export default Breadcrumbs;